<script>
import Vue from 'vue'
// import SousMenu from "@/views/Menu/SousMenu.vue";
import menuData from "../../utils/menu";
import Header from "../../components/Header.vue";

export default Vue.extend({
    name: "Menuprincipal",
    components: {Header},
    data() {
        return {
            menuItems: menuData,
        }
    },
    methods: {
        navigateTo(item) {
            this.$router.push(item.route).catch(() => {});
            this.$root.$emit('show-sous-menu', item);
        }
    }
})
</script>

<template>
    <div class="menu-principal">
        <!-- Header -->
        <Header>
            <template #title_header>
                <span class="text-logo text-white my-0 mr-md-auto font-weight-bold">TRANS'<span class="text-white">APP</span></span>
            </template>
        </Header>

        <!-- Hero Section -->
        <div class="hero-section d-none d-md-block">
            <div class="container mx-auto">
                <h2 class="text-white mb-4">Menu principal</h2>
                <div class="hero-card">
                    <div class="row align-items-center">
                        <div class="col-lg-12">
                            <h1 class="display-5 fw-bold mb-3 text-uppercase">
                                Piloter vos <span class="text-warning">opération de transit</span>
                            </h1>
                            <p class=" mb-0">
                                Traçabilité et Numérisation des Services de Transit et d’Application Professionnelle
                                <br>- Votre bureau de transit dans la poche
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Menu Grid -->
        <div class="container py-5">
            <div class="row">
                <div
                    v-for="(item, index) in menuItems"
                    :key="index"
                    class="col-6 col-md-4 col-lg-3 mb-4"
                >
                    <div
                        class="menu-card card h-100 text-center"
                        :style="{ backgroundColor: item.color }"
                        @click="navigateTo(item)"
                    >
                        <div class="card-body d-flex flex-column align-items-center justify-content-center p-4">
                            <div class="menu-icon mb-4">
                                <i :class="['fas', item.icon, 'fa-3x']"></i>
                            </div>
                            <h5 class="card-title fw-bold text-uppercase mb-0">{{ item.title }}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
<!--        <SousMenu/>-->
    </div>
</template>

<style>
/* Variables */
:root {
    --primary-teal: #2d9b94;
    --dark-bg: #ffffff;
}

/* Global Styles */
.menu-principal {
    min-height: 100vh;
    background: linear-gradient(180deg, var(--dark-bg) 0%, #ffffff 100%);
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}


/* Hero Section */
.hero-section {
    padding: 3rem 0;
    background-image: url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200');
    background-size: cover;
    background-position: center;
    background-blend-mode: overlay;
    background-color: rgba(10, 47, 58, 0.85);
}

.hero-card {
    background: linear-gradient(135deg, rgba(32, 201, 151, 0.95) 0%, rgba(23, 162, 184, 0.95) 100%);
    border-radius: 15px;
    padding: 3rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.hero-card h1 {
    color: white;
    font-weight: 700;
}

.hero-card .text-warning {
    color: #ffc107 !important;
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
}

.hero-card p {
    color: white;
    font-size: 1.1rem;
    line-height: 1.6;
}

/* Menu Cards */
.menu-card {
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    min-height: 200px;
    color: white;
}

.menu-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.menu-icon {
    opacity: 0.9;
}

.card-title {
    font-size: 1rem;
    line-height: 1.4;
}

.dropdown .custom-dropdown {
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 12px;
}

.dropdown .custom-dropdown:focus {
    border: 1px solid white !important;
}

.dropdown .custom-dropdown .text-user {
    font-size: 16px;
    font-weight: 600;
    color: #ffffff !important;
}

.dropdown .custom-dropdown .text-email {
    font-size: 12px;
    color: #ffffff !important;
}

/* Responsive */
@media (max-width: 768px), (max-height: 600px) and (orientation: landscape) {
    .hero-card {
        padding: 2rem;
    }

    .hero-card h1 {
        font-size: 1.75rem;
    }

    .hero-card p {
        font-size: 1rem;
    }

    .menu-card {
        min-height: 180px;
    }
}

@media (max-width: 576px), (max-height: 600px) and (orientation: landscape) {
    .navbar-brand {
        font-size: 1.25rem;
    }

    .hero-section {
        padding: 2rem 0;
    }

    .hero-card {
        padding: 1.5rem;
    }

    .menu-card {
        min-height: 130px;
    }

    .menu-card .card-body {
        padding: 0.75rem !important;
    }

    .menu-icon {
        margin-bottom: 0.5rem !important;
    }

    .menu-icon i {
        font-size: 1.6rem !important;
    }

    .card-title {
        font-size: 0.75rem;
    }
}

/* Phones in landscape: the width no longer matches Bootstrap's "mobile"
   breakpoints, so force the hero to stay hidden and the grid to stay
   at 2 columns using the actual (short) viewport height instead of width. */
@media (max-height: 600px) and (orientation: landscape) {
    .menu-principal .hero-section {
        display: none !important;
    }

    .menu-principal .col-md-4,
    .menu-principal .col-lg-3 {
        flex: 0 0 50% !important;
        max-width: 50% !important;
    }
}
</style>